export const TYPES = {
  GET_ALL_VOUCHER_PACKAGE_SUCCESS: "voucher/GET_ALL_VOUCHER_PACKAGE_SUCCESS",
  GET_VOUCHER_SUCCESS: "voucher/GET_VOUCHER_SUCCESS",
  GET_PACKAGE_DETAIL_SUCCESS: "voucher/GET_PACKAGE_DETAIL_SUCCESS",
  SELECT_REDEEM_SUCCESS: "voucher/SELECT_REDEEM_SUCCESS",
  //cashup
  GET_VOUCHER_BYDATE_SUCCESS: "voucher/GET_VOUCHER_BY_DATE_SUCCESS",
  GET_VOUCHER_REDEEM_BYDATE_SUCCESS:
    "voucher/GET_VOUCHER_REDEEM_BYDATE_SUCCESS",
};
